import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-right-v",
  "use": "icon-arrow-right-v-usage",
  "viewBox": "0 0 28 27",
  "content": "<symbol viewBox=\"0 0 28 27\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-arrow-right-v\">\n<path d=\"M18.7719 14.3354L12.0219 21.0854C11.561 21.5463 10.8132 21.5463 10.3513 21.0854C9.89039 20.6245 9.89039 19.8757 10.3513 19.4148L16.2659 13.5002L10.3513 7.58557C9.89039 7.12468 9.89039 6.37583 10.3513 5.91494C10.8132 5.45405 11.561 5.45405 12.0219 5.91494L18.7719 12.6649C19.2339 13.1258 19.2339 13.8747 18.7719 14.3356V14.3354Z\" fill=\"#202020\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./assets/svg/arrow-right-v.svg
// module id = 100
// module chunks = 0 1 2